import { Eye, PencilSimple, Prohibit, Trash } from "@phosphor-icons/react";

const money = (amount) => {
  return new Intl.NumberFormat("en-MY", {
    style: "currency",
    currency: "MYR",
    minimumFractionDigits: 2,
  }).format(amount || 0);
};

export const CustomerLoanHistoryTable = ({
  canDelete,
  canEditDates,
  customer,
  loans,
  onBlacklist,
  onDelete,
  onEditDates,
  onView,
}) => {
  return (
    <div className="customer-record-table-wrap">
      <table data-testid="customer-record-loans-table">
        <thead>
          <tr>
            <th>Agent Name</th>
            <th>Loan Number</th>
            <th>Loan Date</th>
            <th className="amount">Total Amount</th>
            <th className="amount">Cash On Hand</th>
            <th className="amount">Interest</th>
            <th className="amount">Deposit</th>
            <th className="amount">Stamp Duty</th>
            <th>Remarks / Term</th>
            <th className="amount">Outstanding</th>
            <th className="amount">Earn / Loss (Cash)</th>
            <th>Status</th>
            <th>View</th>
            <th>Blacklist</th>
            {canEditDates && <th>Edit Dates</th>}
            {canDelete && <th>Delete</th>}
          </tr>
        </thead>
        <tbody>
          {loans.map((loan) => {
            const profit = loan.cash_profit_loss ?? 0;
            return (
              <tr key={loan.id} data-testid={`customer-record-loan-${loan.id}`}>
                <td>{customer.owner_name}</td>
                <td>{loan.id.slice(-8).toUpperCase()}</td>
                <td>{loan.loan_date || new Date(loan.created_at).toLocaleDateString()}</td>
                <td className="amount">{money(loan.principal)}</td>
                <td className="amount">{money(loan.cash_on_hand ?? loan.principal)}</td>
                <td className="amount">
                  {money(loan.interest_amount ?? (loan.principal * loan.interest_rate) / 100)}
                </td>
                <td className="amount">{money(loan.deposit_amount)}</td>
                <td className="amount">{money(loan.stamp_duty)}</td>
                <td className="customer-record-remark">{loan.remarks || "—"}</td>
                <td className="amount customer-outstanding">{money(loan.outstanding)}</td>
                <td className={`amount ${profit >= 0 ? "report-credit" : "report-debit"}`}>
                  {money(profit)}
                </td>
                <td>
                  <span className={`status status-${loan.status}`}>
                    {loan.status === "paid" ? "settled" : loan.status}
                  </span>
                </td>
                <td>
                  <button
                    className="customer-icon-button"
                    onClick={() => onView(loan)}
                    data-testid={`customer-record-view-loan-${loan.id}`}
                    aria-label={`View loan ${loan.id.slice(-8).toUpperCase()}`}
                  >
                    <Eye size={17} />
                  </button>
                </td>
                <td>
                  {loan.status !== "blacklisted" && loan.status !== "paid" ? (
                    <button
                      className="customer-icon-button customer-blacklist-button"
                      onClick={() => onBlacklist(loan)}
                      data-testid={`customer-record-blacklist-loan-${loan.id}`}
                      aria-label={`Blacklist loan ${loan.id.slice(-8).toUpperCase()}`}
                      title="Blacklist loan"
                    >
                      <Prohibit size={17} />
                    </button>
                  ) : (
                    <span aria-label="Blacklist action unavailable">—</span>
                  )}
                </td>
                {canEditDates && (
                  <td>
                    <button
                      className="customer-icon-button"
                      onClick={() => onEditDates(loan)}
                      data-testid={`customer-record-edit-dates-${loan.id}`}
                      aria-label={`Edit dates for loan ${loan.id.slice(-8).toUpperCase()}`}
                    >
                      <PencilSimple size={17} />
                    </button>
                  </td>
                )}
                {canDelete && (
                  <td>
                    <button
                      className="customer-icon-button customer-delete-button"
                      onClick={() => onDelete(loan)}
                      data-testid={`customer-record-delete-loan-${loan.id}`}
                      aria-label={`Delete loan ${loan.id.slice(-8).toUpperCase()}`}
                    >
                      <Trash size={17} />
                    </button>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};